// The generated quiz documents, shown in Kho bài as a course of their own.
//
// There is no backend course for these; the board mints them at runtime. They are projected out of
// the single document store (filmstrip/documents.ts) rather than tracked twice, so a set can never
// exist in the rail without existing on the board, or the other way round.

import type { IztContentNode } from '../../api/types.ts';
import { type BoardDocument } from '../filmstrip/documents.ts';
import { i18n } from '../../i18n/index.ts';
import { quizQuestionTotal } from './body.ts';

/** Course id the bank writes into `lessonRef`, so a question knows which generated set it is in. */
export const AI_TEST_COURSE_ID = 'course-ai-tests';

const AI_TEST_SECTION_ID = 'section-ai-tests';

/**
 * The generated sets as a Kho bài course, or null when none exist yet.
 *
 * `type: 'test'` is the real IZTeach word for a bài kiểm tra, so the BKT chip filters these with
 * `contentFilterMatches('assessment', ...)` and needs no special case.
 */
export function buildAiTestCourse(documents: BoardDocument[]): IztContentNode | null {
  const quizzes = documents.filter((item) => item.kind === 'quiz');
  if (quizzes.length === 0) return null;
  return {
    id: AI_TEST_COURSE_ID,
    name: i18n.t('quiz:course.name'),
    sections: [
      {
        id: AI_TEST_SECTION_ID,
        name: i18n.t('quiz:course.section'),
        units: quizzes.map((item) => ({
          id: item.id,
          name: item.title,
          type: 'test',
          homeworkQuestion: item.quiz ? quizQuestionTotal(item.quiz.questions) : 0,
        })),
      },
    ],
  };
}
